export class SupabaseAuthService {
  constructor(client) {
    this.client = client
  }

  async getSession() {
    const { data } = await this.client.auth.getSession()
    return data.session
  }

  onAuthStateChange(callback) {
    const { data } = this.client.auth.onAuthStateChange((_event, session) => {
      callback(session)
    })
    return data.subscription
  }

  async signIn(email, password) {
    const { error } = await this.client.auth.signInWithPassword({ email, password })
    if (error) throw new Error(error.message)
  }

  async signUp(email, password, fullName) {
    const { error } = await this.client.auth.signUp({
      email,
      password,
      options: { data: { full_name: fullName } },
    })
    if (error) throw new Error(error.message)
  }

  async signOut() {
    const { error } = await this.client.auth.signOut()
    if (error) throw new Error(error.message)
  }
}
